<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body" style="height: 800px">
          <form-wrapper :validator="$v.form">
            <form-group
              name="product_code"
              :label="$t('attributes.group_code')"
              :label-position="labelPosition"
              expanded
            >
              <b-input v-model="group_code" disabled expanded></b-input>
            </form-group>

            <div class="columns">
              <div class="column">
                <b-field
                  :label-position="labelPosition"
                  :label="$t('attributes.day')"
                >
                  <b-select v-model="form.day" name="day" expanded>
                    <option
                      v-for="option in dayOptions"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <form-group
                  name="sort"
                  :label="$t('attributes.day_sort')"
                  :label-position="labelPosition"
                  expanded
                >
                  <b-select v-model="form.sort" name="sort" expanded>
                    <option
                      v-for="option in sortOptions"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </form-group>
              </div>
              <div class="column">
                <b-field
                  :label-position="labelPosition"
                  :label="$t('attributes.total_days')"
                >
                  <b-input v-model="days" disabled expanded></b-input>
                </b-field>
              </div>
            </div>

            <form-group
              name="fly_no"
              :label="$t('attributes.fly_no')"
              :label-position="labelPosition"
            >
              <b-autocomplete
                v-model="selectedSchedule"
                name="fly_no"
                field="fly_no"
                :data="filterSchedules"
                :placeholder="
                  $t('message.please_select') + $t('attributes.fly_schedule')
                "
                :open-on-focus="true"
                :keep-first="true"
                :loading="loadingSchedules"
                :check-infinite-scroll="true"
                @typing="onSelectingSchedule"
                @select="onSelectedSchedule"
              >
                <template #default="props">
                  <div class="media fly-schedule-media">
                    <div class="media-left">
                      <p class="has-text-black has-text-weight-semibold">
                        {{ props.option.airline }}
                      </p>
                      <p>
                        <span class="has-text-black has-text-weight-bold">
                          {{ props.option.fly_no }}
                        </span>
                        班機
                      </p>
                    </div>
                    <div class="media-content">
                      <p>
                        出發
                        <span class="has-text-info has-text-weight-semibold">
                          {{ props.option.departure_time }}
                          {{ props.option.departure_city }}
                        </span>
                      </p>
                      <p>
                        到達
                        <span class="has-text-success has-text-weight-semibold">
                          {{ props.option.arrive_time }}
                          {{ props.option.arrive_city }}
                        </span>
                      </p>
                    </div>
                    <div class="media-right">
                      <table class="table schedule-table">
                        <tbody>
                          <tr>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.mon
                                }"
                              >
                                一
                              </span>
                            </td>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.tue
                                }"
                              >
                                二
                              </span>
                            </td>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.wen
                                }"
                              >
                                三
                              </span>
                            </td>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.thr
                                }"
                              >
                                四
                              </span>
                            </td>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.fri
                                }"
                              >
                                五
                              </span>
                            </td>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.sat
                                }"
                              >
                                六
                              </span>
                            </td>
                            <td rowspan="2">
                              <span
                                :class="{
                                  'week-day': true,
                                  'week-check': props.option.sun
                                }"
                              >
                                日
                              </span>
                            </td>
                            <td style="padding-left: 10px">生效時間</td>
                            <td
                              class="has-text-danger has-text-weight-semibold"
                            >
                              {{ props.option.effect_date }}
                            </td>
                          </tr>
                          <tr>
                            <td style="padding-left: 10px">預估天數</td>
                            <td
                              class="has-text-primary has-text-weight-semibold"
                            >
                              {{ props.option.estimated_days }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>
                <template #empty>
                  No results found
                </template>
              </b-autocomplete>
            </form-group>

            <form-group
              name="direction"
              :label="$t('attributes.traffic_direction')"
              :label-position="labelPosition"
              expanded
            >
              <b-select v-model="form.direction" name="direction" expanded>
                <option value="去">去</option>
                <option value="中">中</option>
                <option value="回">回</option>
              </b-select>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ transfer.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>
      </div>

      <b-loading
        :is-full-page="false"
        :active.sync="loadingSchedules"
      ></b-loading>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { debounce } from 'lodash'
import { FLY_SCHEDULE_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TransferForm',

  props: {
    group_code: {
      type: String,
      required: true
    },
    transfer: {
      type: Object,
      required: true
    }
  },
  data() {
    const days = +this.transfer.days
    const dayOptions = [...Array(days).keys()].map(i => i + 1)

    return {
      sending: false,

      days: this.transfer.days,
      form: this.extractFormValues(this.transfer),

      loadingSchedules: false,
      search: this.transfer.fly_no && this.transfer.fly_no.trim(),
      schedules: [],
      filterSchedules: [],

      selectedSchedule: null,
      dayOptions,
      sortOptions: [1, 2, 3, 4, 5],

      labelPosition: 'on-border'
    }
  },
  validations: {
    form: {
      day: { required },
      direction: { required },
      sort: { required },
      fly_id: { required },
      effect_date: { required },
      fly_no: { required }
    }
  },
  computed: {
    formTitle() {
      return this.$t('attributes.add') + this.$t('attributes.fly_schedule')
    }
  },
  watch: {
    transfer(newTransfer) {
      this.days = newTransfer.days
      this.dayOptions = [...Array(this.days).keys()].map(i => i + 1)
      this.form = this.extractFormValues(newTransfer)
    }
  },
  mounted() {
    this.getSchedules()
  },
  methods: {
    extractFormValues(data) {
      return {
        day: data.day,
        direction: data.direction,
        sort: data.sort,
        fly_id: data.fly_id,
        effect_date: data.effect_date,
        fly_no: data.fly_no
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    },
    async getSchedules() {
      const api = `${FLY_SCHEDULE_API}/list`
      const params = { search: null }

      try {
        this.loadingSchedules = true
        const res = await this.axios.get(api, { params })

        this.schedules = res.data.data
        this.filteringSchedules()

        this.initSelectedSchedules()
      } catch (e) {
        this.schedules = []
        this.filterSchedules = []

        notifyService.fetch_error('fly_schedule', e)
      } finally {
        this.loadingSchedules = false
      }
    },
    initSelectedSchedules() {
      if (!this.selectedSchedule) {
        const schedule = this.schedules.find(s => {
          return (
            s.id === this.form.fly_id &&
            s.effect_date === this.form.effect_date &&
            s.fly_no === this.form.fly_no
          )
        })

        if (schedule) {
          this.selectedSchedule = schedule.fly_no
        }
      }
    },
    onSelectingSchedule: debounce(function(search) {
      if (this.search === search) {
        return
      }

      this.search = search
      this.filteringSchedules()
    }, 500),
    filteringSchedules() {
      if (!this.search) {
        this.filterSchedules = this.schedules.slice(0, 100)
      } else {
        const key = this.search.toUpperCase()
        this.filterSchedules = this.schedules.filter(s =>
          s.fly_no.toUpperCase().startsWith(key)
        )
      }
    },
    onSelectedSchedule(option) {
      this.form.fly_id = option.id
      this.form.effect_date = option.effect_date
      this.form.fly_no = option.fly_no
    }
  }
}
</script>

<style lang="scss" scoped>
.fly-schedule-media {
  .media-left {
    margin-right: 10px;
    max-width: 100px;
    min-width: 100px;
    width: 100px;
    overflow: scroll;
  }

  .media-content {
    max-width: 160px;
    min-width: 160px;
    width: 160px;
  }

  .media-right {
    margin-left: 10px;
    max-width: 250px;
    min-width: 250px;
    width: 250px;
  }
}

.schedule-table {
  background: transparent;

  th,
  td {
    text-align: center !important;
    vertical-align: middle !important;
    border: none;
    padding: 0 2px;

    .week-day {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      font-size: 12px;
      color: #fff;
      line-height: 14px;
      text-align: center;
      background-color: #cccccc;
      padding: 2px;

      &.week-check {
        background-color: lightseagreen;
      }
    }
  }
}
</style>
